import { FC, Fragment } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, LabelList, ResponsiveContainer } from "recharts";
import { ChartData, verificationColors } from "./interfaces";

interface ChartProps {
  data: ChartData;
}

interface AgaTickProps {
  payload?: {
    value: string;
  };
  y?: number;
}

const CustomYAxisTick = (props: AgaTickProps) => {
  const { y, payload } = props;
  return (<g transform={`translate(${0},${y + 4})`}>
    <text x={0} y={0}
      textAnchor="start"
      // This fill is equal to sass variable $qes-primary-gray-7
      fill="#504d5c">{payload.value}</text>
  </g>)
}

export const AccuracyGapAnalysisChart: FC<React.PropsWithChildren<ChartProps>> = (props: ChartProps) => {
  return (
    <Fragment>
      <h2 className="header-s aga-scorecard__title">Accuracy Gap Analysis Breakdown</h2>
      <div className="aga-box">
        <div className="header">
          <div className="total-col label-s">Total Verifications Flagged</div>
          <div className="verification-col label-s">Verification Type</div>
          <div className="count-col label-s">Count</div>
        </div>
        <div className="aga-box__contents">
          <div className="total-col">
            <div className="aga-box__big-number">
              {props?.data?.totalInvalidVerifications}
              <div className="label-m">Invalid Verifications</div>
            </div>
          </div>
          <div className="chart" style={{ height: `${props?.data?.invalidVerificationsByType.length * 40}px` }}>
            <ResponsiveContainer>
              <BarChart
                data={props?.data?.invalidVerificationsByType}
                layout="vertical"
              >
                {/* The domain here gives space for the longest bar to display its label */}
                <XAxis type="number" domain={[0, () => Math.round(props?.data?.invalidVerificationsByType[0].invalidVerifications * 1.10)]} hide={true} />
                <YAxis dataKey="invalidVerificationType" type="category" width={180} tick={<CustomYAxisTick />} tickLine={false} />
                <Bar dataKey="invalidVerifications" barSize={12}>
                  {/* We don't know what the types will be or how many there will be, so we just cycle through the colors on loop */}
                  {props?.data?.invalidVerificationsByType.map((d, index) => (
                    <Cell key={d.invalidVerificationType} fill={verificationColors[index % verificationColors.length]} />
                  ))}
                  {/* This fill is equal to sass variable $qes-primary-gray-7 */}
                  <LabelList dataKey="invalidVerifications" position="right" fill="#504d5c" />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
